import { postingAdapters } from './adapters';
import { postingsApi } from './postingsApi';
import { IGetPostingsParams, IGetPostingsResult } from './types';

async function getPostings(
  params: IGetPostingsParams,
  officeId?: string,
): Promise<IGetPostingsResult> {
  const response = await postingsApi.getPostings(params, officeId);

  return postingAdapters.toGetPostingsResult(response);
}

export const postingsService = {
  getPostings,
};
